/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteOrderBillModel as DigiworkMaitreDPosDtoOrderDeleteOrderBillModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Order/delete-order-bill-model';

export interface DeleteOrderBill$Params {
      body?: DigiworkMaitreDPosDtoOrderDeleteOrderBillModel
}

export function deleteOrderBill(http: HttpClient, rootUrl: string, params?: DeleteOrderBill$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteOrderBill.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteOrderBill.PATH = '/api/wtr/OrderBill/deleteorderbill';
